import { serializeCatalogEditor, validateCatalogEditor } from './catalogEditorModel';

export const validateAddonsEditor = (values) => validateCatalogEditor('addons', values);
export const serializeAddonsEditor = (sourceConfig, editor, archivedAt) => (
    serializeCatalogEditor(sourceConfig, { ...editor, scope: 'addons' }, archivedAt)
);
